module.exports = __webpack_public_path__ + "static/media/page09_front.00b12e03.png";